export default {
  name: "State Workforce Agency (SWA) Selection",
  symbol: "list",
  pageInfo: {
    text: "You must select a State Workforce Agency (SWA) to which this Job Order will be routed. You may select any state that has jurisdiction over your intended place(s) of employment. Failure to select a relevant SWA may delay the processing of this application. .",
    coloring: "grey",
    read_more: false,
    isVisible: {
      when: "prelim_4_is_emergency prelim_5_is_livestock",
      operator: "compareMultiFieldValuesAND",
      is: "NO",
    },
  },
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please complete preliminary questions 4 & 5 to determine if a State Workforce Agency (SWA) selection is needed for this application.",
        type: "info",
        isVisible: {
          when: "prelim_4_is_emergency prelim_5_is_livestock",
          is: "undefined",
          operator: "compareMultiFieldValuesOR",
        },
      },
    ],
  },
  sections: [
    {
      name: "Choose a State Workforce Agency (SWA) State",
      isVisible: {
        when: "prelim_5_is_livestock prelim_5_is_livestock",
        is: "NO YES",
        operator: "compareMultiFieldValuesOR_ISArray",
      },
      fields: [
        {
          code: "1",
          machine_name: "eta_790_a13_swa_state_id",
          widget: "select",
          dynamicSelection: [
            "eta_790a_c3_work_state_id",
            {
              array_input: "eta_790a_addendum_b_employment",
              relevant_input: "employment_state_id",
            },
          ],
          label: "State",
          validate: ["required"],
          isVisible: {
            when: "prelim_5_is_livestock",
            is: "NO",
          },
          tooltip:
            "You must select a State Workforce Agency (SWA) to which this Job Order will be routed. You may select any state that has jurisdiction over your intended place(s) of employment. Failure to select a relevant SWA may delay the processing of this application.",
        },
        {
          code: "1",
          machine_name: "eta_790_a13_swa_state_id",
          widget: "select",
          dynamicSelection: [
            "eta_790a_c3_work_state_id",
            {
              array_input: "eta_790a_addendum_b_employment",
              relevant_input: "employment_state_id",
            },
          ],
          label: "State",
          isVisible: {
            when: "prelim_5_is_livestock",
            is: "YES",
          },
        },
      ],
    },
  ],
};
